import {
  // -- GET (list)
  GET_GLOBAL_WEATHER_DATAS_SUCCESS,
  GET_GLOBAL_WEATHER_DATAS_FAILURE,
  // -- CREATE
  CREATE_GLOBAL_WEATHER_DATA_SUCCESS,
  CREATE_GLOBAL_WEATHER_DATA_FAILURE,
  // -- UPDATE
  UPDATE_GLOBAL_WEATHER_DATA_SUCCESS,
  UPDATE_GLOBAL_WEATHER_DATA_FAILURE,
  // -- DELETE
  DELETE_GLOBAL_WEATHER_DATA_SUCCESS,
  DELETE_GLOBAL_WEATHER_DATA_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const globalWeathers = (state = {}, action) => {
  switch (action.type) {
    // -- GET GLOBAL WEATHERS (list)
    case GET_GLOBAL_WEATHER_DATAS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalWeathers.GET_GLOBAL_WEATHER_DATAS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_GLOBAL_WEATHER_DATAS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalWeathers.GET_GLOBAL_WEATHER_DATAS_SUCCESS()', {
        state,
        action
      })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE GLOBAL WEATHER
    case CREATE_GLOBAL_WEATHER_DATA_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalWeathers.CREATE_GLOBAL_WEATHER_DATA_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_GLOBAL_WEATHER_DATA_SUCCESS: {
      const items = state.items || []
      let newItems = [...items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalWeathers.CREATE_GLOBAL_WEATHER_DATA_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE GLOBAL WEATHER
    case UPDATE_GLOBAL_WEATHER_DATA_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalWeathers.UPDATE_GLOBAL_WEATHER_DATA_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_GLOBAL_WEATHER_DATA_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalWeathers.UPDATE_GLOBAL_WEATHER_DATA_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- DELETE GLOBAL WEATHER
    case DELETE_GLOBAL_WEATHER_DATA_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalWeathers.DELETE_GLOBAL_WEATHER_DATA_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_GLOBAL_WEATHER_DATA_SUCCESS: {
      const newItems = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalWeathers.DELETE_GLOBAL_WEATHER_DATA_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    default:
      return state
  }
}
